"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLineOfCoverageDetails = exports.getTypeDisplayNameMap = exports.getTypeFrequencyMap = exports.getRecords = void 0;
var nanoid_1 = require("nanoid");
function getRecords(linesOfCoverageDetails) {
    return linesOfCoverageDetails.map(function (lineOfCoverageDetails) { return ({
        identifier: nanoid_1.nanoid(),
        lineOfCoverageDetails: lineOfCoverageDetails,
    }); });
}
exports.getRecords = getRecords;
function getTypeFrequencyMap(linesOfCoverageDetails) {
    return linesOfCoverageDetails.reduce(function (map, loc) { return map.set(loc.type, (map.get(loc.type) || 0) + 1); }, new Map());
}
exports.getTypeFrequencyMap = getTypeFrequencyMap;
function getTypeDisplayNameMap(linesOfCoverageDetails) {
    return linesOfCoverageDetails.reduce(function (map, loc) {
        var _a;
        if (loc.displayName) {
            var set = (_a = map.get(loc.type)) !== null && _a !== void 0 ? _a : new Set();
            return map.set(loc.type, set.add(loc.displayName));
        }
        return map;
    }, new Map());
}
exports.getTypeDisplayNameMap = getTypeDisplayNameMap;
function getLineOfCoverageDetails(lineOfCoverageDetailsRecords) {
    return lineOfCoverageDetailsRecords.flatMap(function (record) { return record.lineOfCoverageDetails; });
}
exports.getLineOfCoverageDetails = getLineOfCoverageDetails;
